import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Wand2, CalendarDays, Repeat, LogIn, MessageCircle, Printer, ArrowRight, Building2 } from "lucide-react";

const FEATURES = [
  { icon: Wand2, title: "AI Auto-Roster", desc: "Ek click me pura hafta — quota poora, sabka load barabar, night ke baad rest, approved leaves OFF." },
  { icon: CalendarDays, title: "Weekly Grid Editor", desc: "Har cell khud badlein — Morning/Evening/Night apne time ke saath, dekh kar Publish karein." },
  { icon: Repeat, title: "Leave & Shift Swap", desc: "Staff leave mangein, aapas me shift swap karein — in-charge sirf Approve dabaye, duty khud exchange." },
  { icon: LogIn, title: "Staff Apna Login", desc: "Har staff code + phone + PIN se apna roster, aaj ki duty aur swap status dekhta hai." },
  { icon: MessageCircle, title: "WhatsApp Broadcast", desc: "Har staff ko apna duty message ek click me — ya pura roster copy karke group me bhejein." },
  { icon: Printer, title: "Roster PDF + Excel", desc: "Mahine ka colorful roster — Excel (rangi cells ke saath) aur PDF dono me download, notice board ke liye print." },
];

const AUDIENCE = ["Hospitals & Wards", "Nursing Homes", "Coaching & Classes", "Factories & Industry", "Teams & Shops"];

const STEPS = [
  { n: "1", title: "In-charge apni org banaye", desc: "Free — organization ka naam, apna phone + PIN dalein, turant manager ban jayenge." },
  { n: "2", title: "Staff join karein", desc: "Staff khud code + phone + PIN se join karte hain — in-charge approve karta hai." },
  { n: "3", title: "Auto-Roster + Broadcast", desc: "Ek click me roster bana kar publish — sabko WhatsApp par duty pahunch gayi." },
];

const rise = (i = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.5, delay: i * 0.06, ease: "easeOut" },
});

export default function ShiftSyncSection() {
  return (
    <section className="relative overflow-hidden bg-ink py-20 sm:py-24" data-testid="shiftsync-section">
      <div className="pointer-events-none absolute -left-40 top-0 h-96 w-96 rounded-full bg-amber-500/10 blur-[140px]" />
      <div className="pointer-events-none absolute -right-40 bottom-0 h-96 w-96 rounded-full bg-violet-500/10 blur-[140px]" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div {...rise()} className="max-w-3xl">
          <p className="font-mono text-[11px] font-bold uppercase tracking-[0.22em] text-amber-400">Naya Tool — ShiftSync</p>
          <h2 className="mt-3 font-display text-3xl font-extrabold leading-tight text-white sm:text-4xl lg:text-5xl">
            Staff ka duty roster — ab aapki <span className="text-amber-400">website se hi</span>
          </h2>
          <p className="mt-4 text-base text-slate-400 sm:text-lg">
            Hospital ward ho, coaching ki classes ya factory ki shift — in-charge khud apni organization banata hai,
            staff add hote hain, Auto-Roster se pura hafta ban jata hai, aur duty sab tak WhatsApp par pahunchti hai.
            Alag app, alag kharcha — kuch nahi.
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            {AUDIENCE.map((a) => (
              <span key={a} className="rounded-full border border-white/10 bg-white/5 px-4 py-1.5 font-mono text-[11px] font-bold text-slate-300">{a}</span>
            ))}
          </div>
        </motion.div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f, i) => (
            <motion.div key={f.title} {...rise(i + 1)}
              className="h-full rounded-3xl border border-white/10 bg-ink2 p-6 transition-colors hover:border-amber-500/40"
              data-testid={`shiftsync-feature-${i + 1}`}>
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-amber-500/15 text-amber-400"><f.icon size={20} /></span>
              <h3 className="mt-4 font-display text-lg font-extrabold text-white">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">{f.desc}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-3">
          {STEPS.map((s, i) => (
            <motion.div key={s.n} {...rise(i + 1)} className="h-full rounded-3xl border border-white/10 p-6">
              <span className="font-display text-3xl font-extrabold text-amber-500/60">{s.n}</span>
              <h3 className="mt-2 font-display text-base font-extrabold text-white">{s.title}</h3>
              <p className="mt-1.5 text-sm text-slate-400">{s.desc}</p>
            </motion.div>
          ))}
        </div>

        <motion.div {...rise()} className="mt-12 flex flex-col gap-4 sm:flex-row">
          <Link to="/shiftsync" data-testid="shiftsync-cta-create"
            className="group inline-flex items-center justify-center gap-2 rounded-full bg-amber-500 px-8 py-4 font-display text-sm font-extrabold text-ink transition-transform hover:scale-[1.03]">
            <Building2 size={16} /> Apni Organization Banayein — Free <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </Link>
          <Link to="/shiftsync" data-testid="shiftsync-cta-login"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-white/15 px-8 py-4 font-display text-sm font-extrabold text-slate-200 transition-colors hover:border-amber-500/60 hover:text-amber-400">
            Staff Login / Join Karein
          </Link>
        </motion.div>
        <p className="mt-4 font-mono text-[11px] text-slate-600">ShiftSync Voogly Education ka hissa hai — in-charge aur staff sab /shiftsync par login karte hain, site owner ko poora data admin panel me dikhta rehta hai.</p>
      </div>
    </section>
  );
}
